import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

export const Delta = ({
  mini,
  firstValue,
  secondValue,
  noDiffResult = '',
}: {
  mini?: boolean
  firstValue?: number
  secondValue?: number
  noDiffResult?: string
}) => {
  if (firstValue && secondValue) {
    const percentage = ((secondValue - firstValue) / firstValue) * 100.0
    const absPercentage = Math.abs(percentage).toFixed(2)

    if (absPercentage === '0.00') return noDiffResult

    const icon = percentage > 0 ? 'arrow-up' : 'arrow-down'
    const iconColor = percentage > 0 ? 'viridian1000' : 'radicalRed1000'
    const textColor = percentage > 0 ? 'viridian1000' : 'radicalRed1000'
    const backgroundColor = percentage > 0 ? 'viridian200' : 'radicalRed200'

    return (
      <Box
        padding="s4"
        alignItems="center"
        justifyContent="center"
        background={backgroundColor}
        borderRadius={{ all: 'abs016' }}
      >
        <Box flexDirection="row" alignItems="center" justifyContent="center" gap="s2">
          <Icon.Small icon={icon} color={iconColor} />
          <Text
            weight="bold"
            color={textColor}
            size={mini ? '100' : '200'}
          >{`${absPercentage}%`}</Text>
        </Box>
      </Box>
    )
  }

  return noDiffResult
}
